import './radio-button.scss';
import PropTypes from 'prop-types';
import React from 'react';

const RadioButton = props => (
    <div className="RadioButton">
        <input 
            id={props.id} 
            onChange={props.changed} 
            value={props.value} 
            type="radio" 
            checked={props.isSelected}
            aria-label={!props.label ? props.id : undefined}
        />
        <label htmlFor={props.id}>{props.label}</label>
    </div>
);
RadioButton.displayName = 'RadioButton';
RadioButton.propTypes = {
    value: PropTypes.string,
    label: PropTypes.string,
    isSelected: PropTypes.bool.isRequired,
    id: PropTypes.string.isRequired,
    changed: PropTypes.func.isRequired
};
RadioButton.defaultProps = {
    value: '',
    label: ''
};
export default RadioButton;
